import React from 'react'
import Head from 'components/Head'
import SiteLayout from 'components/SiteLayout'
import VideoDetail from 'components/VideoDetail'
import { StoriesStore } from 'stores/stories'
import { PlaylistsStore } from 'stores/playlists'
import { useStoryPageView, useStore } from 'hooks'
import { getServerSideWrapper } from 'utils'
import find from 'lodash/find'

const PlaylistDetailPage = ({ playlist, story, currentVideoSource, videoListTitle }) => {
  useStore(StoriesStore, { current: story, videoList: playlist.stories, currentVideoSource })
  useStore(PlaylistsStore, { current: playlist })
  useStoryPageView(story)

  const adSettings = {
    slot: 'standard-post',
    revContentSlot: 'Barstool-Original',
    keyValues: {}
  }
  return (
    <SiteLayout adSettings={adSettings}>
      <Head playlist={playlist} />
      <VideoDetail title={videoListTitle} type='playlists' adSettings={adSettings} />
    </SiteLayout>
  )
}

export const getServerSideProps = getServerSideWrapper(async ({ params, query }) => {
  const { id } = params
  const { video = null } = query

  const playlist = await PlaylistsStore().findById(id)

  let storyId = playlist.stories[0].id
  if (video) {
    const overrideStory = find(playlist.stories, { id: Number(video) })
    if (overrideStory) {
      storyId = overrideStory.id
    }
  }

  const [story, currentVideoSource] = await Promise.all([
    StoriesStore().findById(storyId),
    StoriesStore().findVideoSource(storyId)
  ])
  return {
    playlist,
    story,
    video,
    currentVideoSource,
    videoListTitle: playlist.title
  }
})

export default PlaylistDetailPage
